<div class="d-flex justify-content-center">
  <div class="card w-100 border-0">
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-12 my-2">
          @if(!isLoadingItems){
          <app-shared-table [items]="items" [enablePagination]="true" [showBtn]="addItem" [enableSorting]="false"
            [initialPageSize]="size" [totalRecords]="totalItemCount" [bodyTemplate]="customBodyTemplate"
            (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" (search)="onSearch($event)"
            [customTemplate]="true" [buttonText]="('GENERAL.CREATE' | translate) + ' ' + ('USER_MANAGEMENT.SPECIALIZED_ROLE' | translate)"
            (buttonClick)="openSpecializedRolesDialog(null,true)"
            [HandelRenderingDataMessage]="HandelRenderingDataMessage">
          </app-shared-table>
          <ng-template #customBodyTemplate let-element>
            @if (!isLoadingFilter) {
            <tr>
              <td>{{ element?.englishName }}</td>
              <td>
                <div class="action-btns">
                  <div>
                    @if(AssignPermissions){
                    <p-menu #menu [model]="SpecializedRolesItemsList" [popup]="true" appendTo="body">
                      <ng-template let-item pTemplate="item">
                        @if(item?.isView){
                        <li pMenuItem (click)="item.command(element)">
                          <a [attr.aria-label]="item.label" class="p-ripple p-element p-menuitem-link">
                            <span [class]="item.icon" class="p-menuitem-icon"></span>
                            <span class="p-menuitem-text">{{ item.label }}</span>
                          </a>
                        </li>
                        }
                      </ng-template>
                    </p-menu>
                    <p-button (onClick)="menu.toggle($event)" icon="pi pi-ellipsis-v" [text]="true"
                      severity="secondary" />
                    }
                  </div>
                </div>
              </td>
            </tr>
            }
            @if (isLoadingFilter) {
            <tr>
              @for (item of items.dataKeys; track $index) {
              <td><p-skeleton /></td>
              }
              <td><p-skeleton /></td>
            </tr>
            }
          </ng-template>
          }
        </div>
      </div>
    </div>
  </div>
</div>
